<template>
    <el-card class="option-card" :class="{ 'no-header': hideHeader, 'no-border': noBorder, 'second-level-header': areaLevel === 2 }" :shadow="shadow" :body-style="bodyStyle">
        <div slot="header" class="option-card__header" v-if="!hideHeader">
            <div class="option-card__header--children option-card__header--info">
                <div class="option-card__header--children option-card__header--info">
                    <template v-if="info.title">
                        <gj-area-title
                            v-if="areaLevel === 2"
                            style="margin-bottom: 0;">
                            <span class="option-header__title second-title">{{info.title}}<slot name="info"></slot></span>
                        </gj-area-title>
                        <template v-else>
                            <span class="option-header__title">{{info.title}}</span>
                            <gj-select class="option-header__select" v-if="info.options && info.options.length" :options="info.options"></gj-select>
                            <span class="option-header__desc" v-if="info.desc">{{ setDate(info.desc) }}</span>
                            <span class="option-header__label option-header__desc" v-if="info.label" v-text="info.label"></span>
                            <slot name="info"></slot>
                        </template>
                    </template>
                </div>
            </div>
            <div class="option-card__header--children option-card__header--action">
                <slot name="action"></slot>
                <div class="option-card-btn__group">
                  <gj-tooltip v-if="help">
                    <template #content>
                      ASIN看板中所有涉及Review相关数据均以国家维度统计
                    </template>
                    <gj-button type="icon" plain>
                      <i class="iconfont iconxiaoxitishi"></i>
                    </gj-button>
                  </gj-tooltip>
                    <gj-button class="option-card-btn__btn" size="medium" type="icon" icon="el-icon-full-screen" v-if="showBtn('full')" @click="handleFull"></gj-button>
                    <gj-button class="option-card-btn__btn" size="medium" type="icon" icon="el-icon-refresh-right" v-if="showBtn('refresh')" @click="handleRefresh"></gj-button>
                    <gj-button class="option-card-btn__btn" size="medium" type="icon" icon="el-icon-download" v-if="showBtn('download')" @click="handleDownload"></gj-button>
                    <gj-button class="option-card-btn__btn" size="medium" type="icon" icon="el-icon-setting" v-if="showBtn('setting')" @click="handleSetting"></gj-button>
                </div>
            </div>
        </div>
        <div class="option-card__content">
            <slot></slot>
        </div>
    </el-card>
</template>

<script>
    import dialog from './dialog'
    import { convertToDate } from "@/utils/date.util";
    const BTN_NAMES = ['full', 'refresh', 'download', 'setting']
    export default {
        name: "option-card",
        props: {
          help:null,
            areaLevel: Number,
            noBorder: Boolean,
            shadow: {
                type: String,
                default: 'never'
            },
            // 展示header
            hideHeader: {
                type: Boolean,
                default: false
            },
            // header左部数据
            info: {
                type: Object,
                default() {
                    return {}
                }
            },
            // header右部操作区域
            actions: {
                type: [Array, String],
                default() {
                    return BTN_NAMES
                },
                validator(val) {
                    const isArray = Array.isArray(val)
                    return isArray ? val.every(v => BTN_NAMES.includes(v)) : BTN_NAMES.includes(val)
                }
            },
            fullData: {
                type: Object,
                default() {
                    return {
                        // 组件名或者组件引用
                        instance: 've-line',
                        propsData: {
                            data: {
                                rows: [],
                                columns: []
                            },
                            settings: {},
                            extend: {}
                        }
                    }
                }
            },
            bodyStyle: {
                type: Object,
                default () {
                    return {
                        padding: '20px'
                    }
                }
            },
            // 全屏展示查找的组件name
            loadComponentName: String
        },
        data () {
            return {

            }
        },
        computed: {
            localActions ({ actions }) {
                return Array.isArray(actions) ? actions : [actions]
            }
        },
        created () {

        },
        methods: {
            setDate(date) {
                let dateArr = date.split("~")
                return `${convertToDate(new Date(dateArr[0]), 'yyyy-MM-dd')}~${convertToDate(new Date(dateArr[1]), 'yyyy-MM-dd')}`
            },
            /**
             * 按钮组控制
             */
            showBtn (name) {
                return this.localActions.includes(name)
            },
            /**
             * 全屏
             */
            handleFull () {
                // this.setChartsFullScreen()
                this.$emit('full')
            },
            /**
             * 刷新当前区域
             */
            handleRefresh () {
                this.$emit('refresh')
            },
            /**
             * 下载
             */
            handleDownload () {
                this.$emit('download')
            },
            /**
             * 打开设置弹窗
             */
            handleSetting () {
                this.$emit('setting')
            },
            /**
             * 弹窗展示charts
             */
            setChartsFullScreen () {
                if (this.fullData && this.fullData.instance) {
                    let instance = dialog.open({
                        componentOptions: {
                            componentConstructor: this.fullData.instance,
                            propsData: this.fullData.propsData
                        }
                    }, {
                        props: {
                            size: 'full-screen'
                        },
                        on: {
                            'cancel': () => {
                                console.warn('cancel')
                            },
                            'confirm': () => {
                                console.warn('confirm')
                            }
                        }
                    })
                }

            },
            /**
             * 当前区域全屏展示（需设置loadComponentName）
             */
            setComponentFullScreen () {
                const {component: vmComponent, instance: vmInstance} = this.findParentComponentInstance(this.$parent)
                if (vmComponent && vmInstance) {
                    console.warn(vmComponent, vmInstance)
                    let instance = dialog.open({
                        componentOptions: {
                            componentConstructor: vmComponent,
                            propsData: vmInstance.$options.propsData,
                            listeners: {},
                            style: {},
                            classes: {}
                        }
                    }, {
                        props: {
                            size: 'full-screen'
                        },
                        on: {
                            'cancel': () => {
                                console.warn('cancel')
                            },
                            'confirm': () => {
                                console.warn('confirm')
                            }
                        }
                    })
                }
                // const ComponentConstructor = Vue.extend(vmComponent)
                // const componentInstance = new ComponentConstructor({
                //     propsData: vmInstance.$options.propsData
                // })
                // const div = document.createElement('div')
                // document.body.appendChild(div)
                // const instance = componentInstance.$mount(div)
            },
            /**
             * 查找loadComponentName匹配的组件引用
             * @param instance 父组件实例
             * @returns {{component: *, instance: ({$options}|*)}|null}
             */
            findParentComponentInstance (instance) {
                if (!this.loadComponentName) return {}
                let component = instance && instance.$options && instance.$options.components ? instance.$options.components[this.loadComponentName] : null
                if (component) return {component, instance}
                instance = instance.$parent
                this.findParentComponentInstance(instance)
            }
        }
    }
</script>

<style lang="scss" scoped>
    .option-card-btn__group{
        /deep/ .el-button.option-card-btn__btn{
            border-radius: 2px;
        }
    }
    /deep/ .el-card__header {
        padding: 12px 20px 0;
        border-bottom: 0;
    }

    .second-level-header /deep/ .el-card__header {
        padding-left: 0;
    }

    .option-header {
        &__title {
            color: #333;
            font-size: 14px;
            font-weight: bold;

            &.second-title {
                font-size: 14px;
            }
        }

        &__select {
            margin-left: 8px;
        }

        &__desc {
            margin-left: 10px;
            font-size: 12px;
            color: #888;
            font-weight: 500;
        }

        &__label {

        }
    }

    .option-card {
        &.no-header {
            margin-top: 0;
        }

        &.no-border {
            border: 0;
        }

        &-btn {
            &__group {
                display: flex;
                justify-content: flex-end;
            }

            &__btn {

                color: #606266;
                margin-left: 10px;
                text-align: center;
                &:hover {
                    color: #1F6EEF;
                }
            }
        }

        &__header {
            display: flex;
            justify-content: center;
            align-items: center;
            min-height: 32px;
            &--children {
                flex: 1;
                display: inline-flex;
                align-items: center;
            }

            &--info {

            }

            &--action {
                justify-content: flex-end;
            }
        }
    }
</style>
